<form id="grouped-step-form" (submit)="onSubmit()" class="step-form" #stepForm>
  @if (headlineTextkey || formWarning) {
    <div class="grid-x grid-margin-x headline-wrapper">
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
      <div class="cell small-12 large-offset-1 large-10 text-center">
        <h1 [attr.role]="formWarning? 'alert' : ''" [class.warning]="formWarning" [innerHTML]="(formWarning? 'step.warning.stepheadline' : headlineTextkey) | translate"></h1>
      </div>
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
    </div>
  }

  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-10 large-8 large-offset-2 step-teaser" [class.warning]="formWarning">
      <p [attr.role]="formWarning? 'alert' : ''" [innerHTML]="(formWarning? 'heizcheck.step.warning.teaser' : headlineTextkey + '.teaser') | translate"></p>
    </div>
    @if (fieldsPresetted) {
      <div class="cell small-12 medium-10 large-8 large-offset-2">
        <p class="preset-hint" [innerHTML]="'heizcheck.step.presethint' | translate"></p>
      </div>
    }
  </div>

  <div class="grid-x grid-margin-x">
    @if (hasHelp) {
      <div class="cell small-12 medium-5 large-4 medium-order-2 help-wrapper">
        <button type="button"class="help-toggle hide-for-medium" (click)="togglePageHelp()">{{(showPageHelp? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}} <i [class]="showPageHelp? 'icon-x-circle' : 'icon-info'"></i></button>
        @if (helpTextkey) {
          <div class="callout lighter-gray step-help" [class.show]="showPageHelp">
            <div [innerHTML]="helpTextkey | translate"></div>
            @if (hasInlineHelp) {
              <button type="button" (click)="toggleInlineHelp()" class="show-for-medium"><i class="icon-help-circle"></i> {{'step.help.more' | translate}}</button>
            }
          </div>
        }
      </div>
    }
    <div class="cell small-12 medium-7 large-offset-2 large-5 medium-order-1" #formWrapper>
      @if (formError) {
        <div role="alert" class="form-errors">
          <p [innerHTML]="textkeyPrefix + '.step.error.' + formError |translate: initBackendErrorPlaceholder() || {fallback: '.step.error.' + formError }"></p>
        </div>
      }

      @if (invoiceErrors) {
        <div role="alert" class="form-errors">
          <p [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.error.invoice.' + invoiceErrors['error'] | translate"></p>
          @if (backendErrors?.length > 0) {
            <ul>
              @for (error of backendErrors; track error) {
                <li [innerHTML]="error | translate: initBackendErrorPlaceholder()"></li>
              }
            </ul>
          }
        </div>
      }

      @for (field of formConfig.getFieldsFromGroup(steps.currentStep.name); track field; let fieldIndex = $index) {
        @if (subHeadlines[field.id]) {
          <h2>{{('heizcheck.group.' + subHeadlines[field.id]) | translate}}</h2>
        }
        @if (field.isActive()) {
          <div formfield [invalidIfEmpty]="false" [inlineHelp]="false" [showInlineHelp]="showInlineHelp" [form]="form" [formModel]="field" [formConfig]="formConfig" [step]="textkeyPrefix" class="formfield {{field.type}} {{field.classes}}" [class.warning]="warningFields.indexOf(field.id) > -1" [class.affected-field]="isAffectedFieldForError(field)"></div>
        }
      }

    </div>
  </div>

  @if (formWarning) {
    <div role="alert" class="form-warnings">
      <div class="grid-x grid-margin-x">
        <div class="cell large-8 large-offset-2">
          <h3 [innerHTML]="'step.warning.headline' | translate"></h3>
          <p [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.warning.' + formWarning | translate: warningPlaceholder"></p>
        </div>
        <div class="cell medium-5 large-offset-2">
          <button type="button" class="button hollow" aria-controls="grouped-step-form" (click)="scrollToField(this.warningFields)" [innerHTML]="'step.warning.button' | translate"></button>
        </div>
      </div>
    </div>
  }
  @if (formWarning) {
    <div class="grid-x grid-margin-x">
      <div class="cell large-8 large-offset-2">
        <p class="step-button-hint" [innerHTML]="'step.warning.next' | translate"></p>
      </div>
    </div>
  }

  <app-step-buttons [nextClass]="loading? 'loading' : ''" [previousLink]="previousStep? previousStep.path : null" [nextLink]="steps?.nextStep? steps.nextStep.path : null" [nextDisabled]="!form.valid" (onNextClick)="submitClicked()"></app-step-buttons>
</form>
